import {ScoresListWidgetStore} from './scores-list-widget.store';
import {ACTION_TYPES} from "../../core/consts";
import {ModuleController} from "../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../infrastructure/domain-services/base-managed-service";
import {ScoresListWidgetConfig} from "./scores-list-widget.config";
import {ScoresListWidgetHandlers} from "./handlers/scores-list-widget.handlers";

export class ScoresListWidgetController extends ModuleController {
  store: ScoresListWidgetStore;

  static injectables = [...BaseManagedService.injectables, ScoresListWidgetConfig, ScoresListWidgetStore, ScoresListWidgetHandlers];

  onResetState() {
    this.action(ACTION_TYPES.fetch);
  }
}
